import React from 'react'
import PropTypes from 'prop-types'

import './styles/imagePreview.css'

export const ImagePreview = ({ dataUri, isFullscreen }) => {
  return (
    <div className={`demo-image-preview ${isFullscreen ? 'demo-image-preview-fullscreen' : ''}`}>
      <img src={dataUri} alt='' />
    </div>
  )
}

ImagePreview.propTypes = {
  dataUri: PropTypes.string,
  isFullscreen: PropTypes.bool,
}

export default ImagePreview
